module.exports = __webpack_public_path__ + "static/img/icon_cloud1.0fb1ad5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/cloud/images/icon_cloud1.jpg
// module id = Q7KC
// module chunks = 21